import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import {
  getSalaryReport,
} from "../../../../services/workspace/payroll.service";

const actions_type = {
  DELETE: "DELETE",
  ADD_EDIT: "ADD_EDIT",
};

const items = [{ label: "Attendance Reports", path: "" }];

const AttendanceReports = () => {

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    handleSearchChange,
    handlePageChange,
    openModal,
    sortingUIProps,
    search

  } = useCommonFetch(getSalaryReport, {
    dataPath: "payrollAttendance",
    totalPath: "payrollAttendance.meta.total",
    errorMessage: "Failed to fetch attendance data!",
    debounceDelay: 500,
    sortingOptions: [
      { label: "Name", field: "name" }, 
      // { label: "Abbreviation", field: "abrv" },
    ],
    sortingModule: "payrollAttendance",
    orderParamNames: { orderByKey: "order_by", orderTypeKey: "order_type", includeDisabledKey: "includeDisabled" },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,

    dataTransformer: (data) => {
      const list = Array.isArray(data) ? data : data?.data ?? [];
      if (!Array.isArray(list) || list.length === 0) {
        return { data: [] };
      }

      const transformedData = list.map((item) => ({
        ...item,
        id: { data: item.user?.uuid ?? item.uuid, variant: "text" },
        name: {
          data: {
            name: item.user?.name ?? "Unknown",
            email: item.user?.email ?? "",
            id: item.user?.code ?? "N/A",
            image: item.user?.image || item.photo || null,
            link: item.user?.uuid ? `/staff/${item.user.uuid}` : "#",
          },
          variant: "profile",
        },
        present: {
          data: item.present ?? "-",
          className: "",
          variant: "text",
        },
        leave: {
          data: item.leave ?? "-",
          className: "",
          variant: "number",
        },
        unpaid_leaves: {
          data: item.unpaid_leaves ?? "-",
          className: "",
          sticky: false,
          variant: "text",
        },
        absent: {
          data: item.absent ?? "-",
          className: "",
          sticky: false,
          variant: "text",
        },
        holidays: {
          data: item.holidays ?? "-",
          className: "",
          sticky: false,
          variant: "text",
        },
        payable_days: {
          data: item.payable_days ?? "-",
          className: "",
          sticky: false,
          variant: "text",
        },
      }));

      return { data: transformedData };
    },
  });

  const TableHeaderData = [
    {
      label: "Staff Name",
      key: "name",
    },
    {
      label: "Days Present",
      key: "present",
    },
    {
      label: "Leaves (Paid)",
      key: "leave",
    },
    {
      label: "Leaves (Unpaid)",
      key: "unpaid_leaves",
    },
    {
      label: "Absent",
      key: "absent",
    },
    {
      label: "Holidays",
      key: "holidays",
    },
    {
      label: "Payable Days",
      key: "payable_days",
    },
  ];
  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        filter={false}
        shorting
        sortingModule="payrollAttendance"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className={" bg-white"}>
        <CommonTable
        search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />
      </div>
    </div>
  );
};
export default AttendanceReports;
